import React, { useState, useEffect } from 'react';
import { products } from '../../data/mockData';
import ProductCard from '../ui/ProductCard';
import { ProductSkeleton } from '../ui/Skeleton';

const FeaturedProducts = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading state for workspace experience
    const timer = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6 mb-16 md:mb-20">
          <div className="max-w-2xl">
            <span className="text-luma-primary text-[10px] font-bold tracking-[0.3em] uppercase mb-4 block">Selected for You</span>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-luma-text">Registry <span className="italic">must-haves</span>.</h2>
          </div>
          <button className="group flex items-center gap-3 text-xs font-bold tracking-[0.2em] uppercase border-b-2 border-luma-sand pb-2 hover:border-luma-primary transition-all">
            Explore All Essentials
            <span className="group-hover:translate-x-2 transition-transform duration-300">→</span>
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-16">
          {loading 
            ? [...Array(4)].map((_, i) => <ProductSkeleton key={i} />)
            : products.map(product => (
                <ProductCard key={product.id} product={product} />
              ))
          }
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;